import React, { Suspense } from "react";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { Section } from "../../Common/layout/Section";
import { SocialManagement } from "./Social";
import { Switch } from "react-router-dom";
import { Permissions } from "../../../util/Permissions";

const SocialManagementPages = () => {
    return <>
        <AsideMenu>
            <UserGroupMenu destination="/social" />
        </AsideMenu>
        <Section>
            <Suspense fallback={<LayoutSplashScreen />}>
                <Switch>
                    <ContentRoute path="/social/:userGroup" permission={Permissions.SOCIAL} component={SocialManagement} />
                </Switch>
            </Suspense>
        </Section>
    </>
};

export default SocialManagementPages;
